export const TOGGLE_IS_AUTH = 'TOGGLE_IS_AUTH';

export function toggleIsAuth(isAuth){
    return{
        type: TOGGLE_IS_AUTH,
        mainState: {
            isAuth: isAuth
        }
    }
}